import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioHierarquiaAssuntoPorNaturezaReducer(state = initialState.relatorioHierarquiaAssuntoPorNatureza, action){
    switch(action.type) {
        case types.RELAT_HIERARQUIA_ASSUNTO_POR_NATUREZA:
            
            return action.relatorioHierarquiaAssuntoPorNatureza;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioHierarquiaAssuntoPorNaturezaReducer.js
 **/